// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"116":"37df47f2","538":"74570896","983":"0476a0d3"}[chunkId] + ".chunk.js";
};